var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.imageGallery.length > 0)?_c('div',{class:_vm.className},[_c('gallery',{attrs:{"items":_vm.data.imageGallery},scopedSlots:_vm._u([{key:"item",fn:function(item){return [_c('asset',{attrs:{"asset":item.image}})]}}],null,false,321934580)})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }